import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snap from 'snapsvg';
import { DEVICE } from '../../../../constants';
import DeviceContext from '../device-context';
import './style';

class Path extends Component {
  static propTypes = {
    coordinates: PropTypes.array,
    r: PropTypes.number,
    width: PropTypes.number,
    svgSetting: PropTypes.object,
  };

  state = {
    coordinates: '',
  };

  componentDidMount() {
    this.generateCoordinates();
    // console.log(this.props.coordinates);
  }

  generateCoordinates = () => {
    const { coordinates, r } = this.props;
    if (!coordinates) return;
    let arr = [];
    if (this.context === DEVICE.PC) {
      // pc 曲线路径
      arr = coordinates.map((item, index) => {
        const coor = index === 0
          ? `M${item[0].x} ${item[0].y}C${item[1].x} ${item[1].y} ${item[2].x} ${item[2].y} ${item[3].x} ${item[3].y}`
          : `C${item[1].x} ${item[1].y} ${item[2].x} ${item[2].y} ${item[3].x} ${item[3].y}`;
        return coor;
      });
    } else {
      // 移动端 折线路径
      // debugger;
      arr = coordinates.map((item, index) => {
        const cmd = index === 0 ? 'M' : 'L';
        return `${cmd}${item.x + r},${item.y + r}`;
      });
    }
    this.setState({ coordinates: arr.join('') }, () => {
      this.creatSvg();
    });
  }

  creatSvg = () => {
    const snapPath = Snap('#svgPath');
    const myPath = snapPath.path(this.state.coordinates);
    myPath.attr({
      id: 'Path',
      fill: 'none',
      strokeWidth: this.props.width,
      stroke: '#fff',
      strokeLinecap: 'round',
      strokeMiterLimit: '10',
      strokeDasharray: '.1% 2%',
      strokeLinejoin: 'round',
    });
  }

  render = () => {
    const { svgSetting } = this.props;
    return (
      <svg
        id="svgPath"
        width={svgSetting.width}
        height={svgSetting.height}
        viewBox={`0 0 ${svgSetting.viewBox}`}
        preserveAspectRatio="xMinYMin meet"
      />
    );
  }
}

Path.contextType = DeviceContext;

export default Path;
